// Angular dependencies
import { Injectable } from '@angular/core';

import { ApiService, AuthService } from '../core/upgraded-providers';

import { Subject } from 'rxjs';

@Injectable()
export class ArenaService {
    _destroySbj: Subject<void> = new Subject();

    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService
    ) {
    }

    async getOffers(): Promise<{ cost: string, steamKey?: string }> {
        try {
            const response = await this._apiSrv.get('arena/order/offer');

            return response;
        } catch (err) {
            throw err;
        }
    }

    async getPurchase(): Promise<{ steamKey: string }> {
        try {
            const response = await this._apiSrv.post('arena/order/purchase');

            this._authSrv.check();

            return response;
        } catch (err) {
            throw err;
        }
    }
}
